jQuery(function ($) {
	// Handle Clicks
	$(".form-edit-button").on("click", function (e) {
		e.preventDefault();

		let $form = $(this).parents(".woocommerce-form");
		$form.addClass("form-mode__edit");

		// Find [data-required] fields and add required attribute
		$form.find("[data-required]").each(function () {
			$(this).attr("required", "required");
		});
	});
	$(".form-cancel-button").on("click", function (e) {
		e.preventDefault();

		let $form = $(this).parents(".woocommerce-form");
		$form.removeClass("form-mode__edit");

		// Find [data-required] fields and remove required attribute
		$form.find("[data-required]").each(function () {
			$(this).removeAttr("required");
		});
	});
});
